import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./ApartmentSection.css";

// 🔹 Read More Component
function ReadMore({ text, limit = 130 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;
  if (text.length <= limit) return <p>{text}</p>;

  return (
    <p>
      {expanded ? text : text.slice(0, limit) + "…"}
      <button
        className="read-more-btn"
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? " Read Less" : " Read More..."}
      </button>
    </p>
  );
}

// 🔹 Main Component
export default function ApartmentSection({
  projectId,
  apartment = {},
  onCtaClick,
}) {
  const { flats = [], heading = "" } = apartment;

  // ✅ Hide if no data
  if (!flats.length) return null;

  const icons = [
    { file: "house_icon.webp", label: "Unit Size", key: "unitSize" },
    { file: "number_icon.png", label: "Quantity", key: "quantity" },
    { file: "config_icon.png", label: "Config", key: "config" },
  ];

  return (
    <section className="apartment-section section" id="pricing">
      <div className="container">

        <h2 className="section-heading">
          {heading || "Available Configurations"}
        </h2>

        {flats.map((flat, i) => (
          <article
            key={i}
            className={`apt-row ${i % 2 !== 0 ? "apt-row--reversed" : ""}`}
          >
            
            {/* 🔹 IMAGE */}
            <figure className="apt-row__photo">
              <img
                src={uploadsUrl(
                  projectId,
                  `${projectId}_apartment${i + 1}.webp`
                )}
                alt={flat.title || "Apartment image"}
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/fallback.webp";
                }}
              />
            </figure>

            {/* 🔹 DETAILS */}
            <div className="apt-row__details">
              <h3>{flat.title || "Apartment"}</h3>

              <ReadMore text={flat.description} limit={130} />

              {/* 🔹 ICON DATA */}
              <div className="apt-row__icons">
                {icons.map(({ file, label, key }) => (
                  <div key={key} className="apt-icon-item">
                    <img
                      src={`https://microsite.thehomestore.co.in/uploads/${file}`}
                      alt={label}
                      loading="lazy"
                    />
                    <span>{flat[key] || "N/A"}</span>
                  </div>
                ))}
              </div>

              {/* 🔹 FOOTER */}
              <div className="apt-row__footer">
                <span className="apt-price">
                  {flat.price || "Price on Request"}
                </span>

                {/* ✅ FINAL CTA (IMPORTANT FIX) */}
                <button
                  className="btn-primary"
                  onClick={() =>
                    onCtaClick?.(
                      `Apartment CTA - ${flat.config || "Unknown"}`,
                      false,
                      {
                        flat: flat.config,
                        title: flat.title,
                        price: flat.price,
                        unitSize: flat.unitSize,
                      }
                    )
                  }
                >
                  {flat.getMore || "Get More Details"}
                </button>

              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}